import List from './List'

export default function Logs(props) {
  return <List {...props} />
}
